<template>
    <div ref="selectedFilters" :class="['selected-filters relative', {'fixed': fixedFilters}]">
<!--        Combo Tariff-->
<!--        <base-button-->
<!--                v-for="(item, key) in presentFilters"-->
        <base-button
                v-for="(item, key) in filters"
                :key="key"
                :style="{'order': 0 - key}"
                class="mr-5 mb-5"
                padding="4px 8px">
            <div v-if="item.Type === 'hotelQuota'">
                <svg width="15px" height="15px" fill="var(--white-color)">
                    <use xlink:href="../../assets/images/sprite.svg#hotel"></use>
                </svg>
            </div>
            <div v-else-if="item.Type === 'aviaQuota'">
                <svg width="15px" height="15px" fill="var(--white-color)">
                    <use xlink:href="../../assets/images/sprite.svg#flight"></use>
                </svg>
            </div>
            <div v-else-if="item.Type === 'busTransferQuota'">
                <svg width="15px" height="15px" fill="var(--white-color)">
                    <use xlink:href="../../assets/images/sprite.svg#bus"></use>
                </svg>
            </div>
            <div v-else-if="item.Type === 'railwayTransferQuota'">
                <icon name="train" width="20px" height="20px" fill="var(--white-color)" />
            </div>
            <span v-else-if="item.name">
                {{item.name}}
            </span>
            <span v-else>
                {{item.Name}}
            </span>
            <svg @click="remove(item, key)" class="close-icon">
                <use xlink:href="../../assets/images/sprite.svg#close"></use>
            </svg>
        </base-button>

        <div class="btn-wrap flex">
            <div v-show="showMoreBtn"
                 @click="toggleFilters()"
                 :class="['more-btn pointer', {'rotate': !moreBtnStatus}]">
            </div>

            <div @click="clearAllFilters()" class="clear-all-filters pointer ml-4">
            </div>
        </div>
    </div>
</template>

<script>
    import {bus} from "../../main";

    export default {
        name: "selected-filters",
        props: {
            filters: {
                type: Array,
                default: () => []
            }
        },
        data() {
            return {
                showMoreBtn: false,
                moreBtnStatus: true,
                fixedFilters: false,
                windowTop: 0
            }
        },
        // Combo Tariff
        // computed: {
        //     presentFilters() {
        //         let res = [];
        //         this.filters.forEach(x => {
        //             let helper = 0;
        //             res.forEach(x2 => {
        //                 // Проверка дублей
        //                 if (
        //                     x.Type === x2.Type &&
        //                     (x.name && x2.name ? x.name === x2.name : x.Name === x2.Name)
        //                 ){
        //                     helper++
        //                 }
        //             });
        //             if (helper < 1) {
        //                 res.push(x);
        //             }
        //
        //         });
        //         return res
        //     },
        // },
        created() {
            // window.addEventListener("scroll", this.windowScroll);
            window.addEventListener("resize", this.resize);
            bus.$on("removeTicketPrice", () => {
                const isTicket = this.$route.fullPath.includes("Individuals/Avia");
                if (isTicket) {
                    this.removePrice()
                }
            });
            bus.$on("ticket_fixed_filters", val => {
                this.fixedFilters = val;
            })
        },
        mounted() {
            this.checkShowMoreBtn()
        },
        updated() {
            this.checkShowMoreBtn()
        },
        methods: {
            // windowScroll(e) {
            //     const filters = this.$refs.selectedFilters;
            //     const filtersReact = filters.getBoundingClientRect();
            //     const windowTop = e.target.scrollingElement.scrollTop;
            //     if(filtersReact.bottom < 0 && this.windowTop === 0) {
            //         this.windowTop = windowTop;
            //     }
            //
            //     if(this.windowTop > windowTop || this.windowTop === 0) {
            //         this.windowTop = 0;
            //         filters.classList.remove("fixed")
            //     } else {
            //         filters.classList.add("fixed")
            //     }
            // },
            resize() {
                this.checkShowMoreBtn()
            },
            checkShowMoreBtn() {
                const selectedFilters = this.$refs.selectedFilters;
                const scrollHeight = selectedFilters.scrollHeight;
                this.showMoreBtn = scrollHeight > 56;
                if(!this.showMoreBtn)
                    selectedFilters.style.height = "46px"
            },
            toggleFilters() {
                this.moreBtnStatus = !this.moreBtnStatus;
                const filters = this.$refs.selectedFilters;

                if(!this.moreBtnStatus) {
                    filters.style.height = "auto"
                } else {
                    filters.style.height = "46px"
                }
            },
            clearAllFilters() {
                this.filters.forEach((x, i) => {
                    if (x.Type === "aviaQuota") {
                        this.remove(x, i)
                    }
                });

                let params = this.$route.params.searchParams.split("&");
                let index;
                params.forEach((x, i) => {
                    if (x.includes('currency=')) index = i + 1
                });
                params = params.filter((x, i) => i < index);

                params = params.join("&");
                if (this.$route.params.searchParams !== params)
                    this.$router.push(params);

                const filters = [];
                this.$emit("change", {
                    filters,
                    sendRequest: true
                })
            },
            remove(item, key) {
                let params = this.$route.fullPath.split("&");
                params = params.map(x => {
                    if (item.Type === "AirService") {
                        if (x.includes("tariff")) {
                            // Combo Tariff
                            // const keys = this.filters
                            //     .filter(x2 => x2.Type === item.Type && x2.Name === item.Name)
                            //     .map(x2 => ''+x2.Key);

                            x = x.split("=")[1]
                                .split(",")
                                .filter(x2 => x2 != item.Key);
                                // .filter(x2 => !keys.includes(x2)); //Combo Tariff

                            if (x.length) {
                                return `tariff=${x.join(",")}`
                            } else {
                                return null
                            }
                        } else {
                            return x
                        }
                    } else if (item.Type === "Transplantation_0") {
                        if (x.includes("departureFlightNoTransfer")) {
                            return null
                        } else {
                            return x
                        }
                    } else if (item.Type === "Transplantation_1") {
                        if (x.includes("departureFlightNumberTransfer")) {
                            x = x.split("=")[1];
                            x = +x - 1;
                            if(x) {
                                return `departureFlightNumberTransfer=${x}`
                            } else {
                                return null
                            }
                        } else {
                            return x
                        }
                    } else if (item.Type === "Transplantation_2") {
                        if (x.includes("departureFlightNumberTransfer")) {
                            x = x.split("=")[1];
                            x = +x - 2;
                            if(x) {
                                return `departureFlightNumberTransfer=${x}`
                            } else {
                                return null
                            }
                        } else {
                            return x
                        }
                    } else if (item.Type === "Transplantation_0_a") {
                        if (x.includes("arrivalFlightNoTransfer")) {
                            return null
                        } else {
                            return x
                        }
                    } else if (item.Type === "Transplantation_1_a") {
                        if (x.includes("arrivalFlightNumberTransfer")) {
                            x = x.split("=")[1];
                            x = +x - 1;
                            if(x) {
                                return `arrivalFlightNumberTransfer=${x}`
                            } else {
                                return null
                            }
                        } else {
                            return x
                        }
                    } else if (item.Type === "Transplantation_2_a") {
                        if (x.includes("arrivalFlightNumberTransfer")) {
                            x = x.split("=")[1];
                            x = +x - 2;
                            if(x) {
                                return `arrivalFlightNumberTransfer=${x}`
                            } else {
                                return null
                            }
                        } else {
                            return x
                        }
                    } else if (item.Type === "Airport") {
                        if (x.includes("airportDeparture")) {
                            x = x.split("=")[1]
                                .split(",")
                                .filter(x2 => x2 != item.Code);
                            if (x.length) {
                                return `airportDeparture=${x.join(",")}`
                            } else {
                                return null
                            }
                        } else {
                            return x
                        }
                    } else if (item.Type === "aAirport") {
                        if (x.includes("airportArrival")) {
                            x = x.split("=")[1]
                                .split(",")
                                .filter(x2 => x2 != item.Code);
                            if (x.length) {
                                return `airportArrival=${x.join(",")}`
                            } else {
                                return null
                            }
                        } else {
                            return x
                        }
                    } else if (item.Type === "AirLine") {
                        if (x.includes("airlines")) {
                            x = x.split("=")[1]
                                .split(",")
                                .filter(x2 => x2 != item.Code);
                            if (x.length) {
                                return `airlines=${x.join(",")}`
                            } else {
                                return null
                            }
                        } else {
                            return x
                        }
                    } else if (item.Type === "price") {
                        if (x.includes("minPrice") || x.includes("maxPrice")) {
                            return null
                        } else {
                            return x
                        }
                    } else if (item.Type === "dTime") {
                        if (x.includes("timeDepartureFrom") || x.includes("timeDepartureTo")) {
                            return null
                        } else {
                            return x
                        }
                    } else if (item.Type === "aTime") {
                        if (x.includes("timeArrivalFrom") || x.includes("timeArrivalTo")) {
                            return null
                        } else {
                            return x
                        }
                    } else if (item.Type === "aviaQuota") {
                        if (x.includes("aviaQuota")) {
                            return "aviaQuota=7"
                        } else {
                            return x
                        }
                    }
                }).filter(x => x);

                params = params.join("&");
                if (this.$route.params.searchParams !== params)
                    this.$router.push(params);

                const filters = this.filters.filter((x, i) => i !== key);
                this.$emit("change", {
                    filters,
                    sendRequest: true
                })
            },
            removePrice() {
                let key = this.filters.map(x => x.Type).indexOf("price");
                if (key !== -1) {
                    this.$nextTick(() => {
                        const filters = this.filters.filter((x, i) => i !== key);
                        this.$emit("change", {
                            filters,
                            sendRequest: false
                        })
                    })
                }
            }
        },
        watch: {
            showMoreBtn(val) {
                if (!val) {
                    this.moreBtnStatus = true
                }
            }
        },
        beforeDestroy() {
            // window.removeEventListener("scroll", this.windowScroll);
            window.removeEventListener("resize", this.resize);
        }
    }
</script>

<style scoped>
    .selected-filters {
        background-color: var(--white-color);
        padding: 10px 120px 10px 60px;
        display: flex;
        flex-wrap: wrap;
        overflow: hidden;
        height: 46px;
        transition: all .2s;
    }
    .selected-filters.fixed {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
        z-index: 1000;
    }

    .selected-filters /deep/ .base-button {
        border-radius: 20px;
        font-size: 15px;
        max-height: 28px;
        cursor: default;
    }
    .selected-filters /deep/ .base-button .hover-effect {
        border-radius: 20px;
    }
    .selected-filters /deep/ .base-button:hover {
        filter: brightness(100%);
    }

    .selected-filters .close-icon {
        width: 8px;
        height: 8px;
        fill: rgba(255, 255, 255, 0.5);
        margin-left: 4px;
        transition: all .2s;
        cursor: pointer;
        z-index: 2;
    }
    .selected-filters .btn-wrap {
        position: absolute;
        top: 11px;
        right: 60px;
        line-height: 26px;
    }
    .selected-filters .btn-wrap .more-btn,
    .selected-filters .btn-wrap .clear-all-filters {
        background-color: #f1f1f1;
        border-radius: 50%;
        width: 24px;
        height: 24px;
        display: flex;
        align-items: center;
        justify-content: center;
        transform: rotate(-90deg);
        cursor: pointer;
        transition: all .2s;
    }
    .selected-filters .btn-wrap .more-btn.rotate {
        transform: translateX(2px) rotate(90deg);
    }
    .selected-filters .btn-wrap .more-btn::before {
        content: "";
        border-left: 2px solid var(--primary-color);
        border-bottom: 2px solid var(--primary-color);
        width: 8px;
        height: 8px;
        transform: translateX(2px) rotate(45deg);
    }
    .selected-filters .btn-wrap .clear-all-filters::before,
    .selected-filters .btn-wrap .clear-all-filters::after {
        content: "";
        background-color: var(--primary-color);
        width: 14px;
        height: 1.5px;
        position: absolute;
        top: calc(50% - 1px);
        left: calc(50% - 7px);
        transform: rotate(45deg);
        border-radius: 2px;
    }
    .selected-filters .btn-wrap .clear-all-filters::before{
        transform: rotate(-45deg);
    }

    .selected-filters .btn-wrap .more-btn:hover,
    .selected-filters .btn-wrap .clear-all-filters:hover {
        background-color: #e1e1e1;
    }
    .selected-filters .btn-wrap .clear-all-filters svg,
    .selected-filters .btn-wrap .clear-all-filters img {
        transform: translateX(-1px);
    }
</style>
